import { zodResolver } from "@hookform/resolvers/zod";
import { Box, Grid } from '@mui/material';
import { useCallback, useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { ContextOperacionNuevo, ContextOperacionNuevoType } from "../../NuevoSistema";
import { OperacionLCSLHPTIInsert } from "./types/dto";
import { OperacionLCSLHPTIFields } from "./types/fields";
import { FormOperacionLCSLHPTI, schemaFormOperacionLCSLHPTI } from "./types/types";
import SeccionNuevoLCSLHPTITablaValores from "./components/SeccionNuevoLCSLHPTITablaValores";
import { HttpLCSLHPTI } from "./api/httpLCSLSHPTI";
import SeccionNuevoLCSLHPTIDatosOperacion from "./components/SeccionNuevoLCSLHPTIDatosOperacion";
import { useSubmitOperacion } from "../../hooks/useSubmitOperacion";

interface NuevoSistemaLCSLHPTIProps {
  codSistemaPrincipal: number
}

const NuevoSistemaLCSLHPTI = ({ codSistemaPrincipal }: NuevoSistemaLCSLHPTIProps) => {
  const { submitOperacion } = useSubmitOperacion();

  const formMethods = useForm<FormOperacionLCSLHPTI>({
    resolver: zodResolver(schemaFormOperacionLCSLHPTI),
    defaultValues: {
      [OperacionLCSLHPTIFields.FechaSolicitud]: new Date(),
      [OperacionLCSLHPTIFields.CodPais]: codSistemaPrincipal,
      [OperacionLCSLHPTIFields.TablaValores]: []
    }
  })

  const handleCrearOperacion = useCallback(
    (data: OperacionLCSLHPTIInsert) => {
      submitOperacion(data, {
        apiCall: HttpLCSLHPTI.post,
        codSistemaPrincipal,
      });
    },
    [codSistemaPrincipal, submitOperacion]
  );

  const { setSavePromise, setSendPromise, codSistema } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)

  useEffect(() => {
    const onSend = () => formMethods.handleSubmit(data => handleCrearOperacion(data))
    setSendPromise(onSend)
  }, [formMethods, handleCrearOperacion])

  return (
    <Box>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <SeccionNuevoLCSLHPTIDatosOperacion formMethods={formMethods} codSistemaPrincipal={codSistemaPrincipal} codSistema={codSistema} />
        </Grid>
        <Grid item xs={12}>
          <SeccionNuevoLCSLHPTITablaValores formMethods={formMethods} codSistemaPrincipal={codSistemaPrincipal} />
        </Grid>
      </Grid>
    </Box>
  )
}

export default NuevoSistemaLCSLHPTI
